var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-container"},[_c('HeaderMod'),_c('div',{staticClass:"m-content main"},[(_vm.newsInfoData.title)?_c('h3',{staticClass:"news-title"},[_vm._v(_vm._s(_vm.newsInfoData.title)),_c('span',{staticClass:"f-block-line"})]):_vm._e(),_c('div',{staticClass:"news-content",domProps:{"innerHTML":_vm._s(_vm.newsInfoData.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }